/** Minimal auth slice — `userRole` for gated UI (session read once at init). */
import { createSlice } from "@reduxjs/toolkit";
import { getSessionData } from "utils/common";

const session = getSessionData() || {};
const initialState = {
  userRole: session?.roleName || session?.RoleName || session?.userRole || "User",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserRole: (state, action) => {
      state.userRole = action.payload || "User";
    },
  },
});

export const { setUserRole } = authSlice.actions;
export default authSlice.reducer;
